import { css, keyframes } from 'styled-components'

// Shared, reusable motion primitives — keep usage subtle and consistent.
// Import: `import { fadeInUp, EASE, duration } from '@styles/animations'`.
// A global `@media (prefers-reduced-motion: reduce)` guard neutralizes these,
// so always express motion through these keyframes / standard easing.

export const EASE = 'cubic-bezier(0.4, 0, 0.2, 1)'

export const duration = {
  fast: '120ms',
  overlay: '160ms',
  enter: '240ms',
  staggerStepMs: 40, // step between successive list/grid items
  sheetMs: 350, // full-screen modal slide — shared by the CSS transition and its close timeouts
} as const

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const scaleIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`

export const slideInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(-6px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`

export const shimmer = keyframes`
  from {
    background-position: -200% 0;
  }
  to {
    background-position: 200% 0;
  }
`

// Shared list-row entrance — one flat fade, plays once per row mount.
// Neutralized by the global prefers-reduced-motion guard.
export const rowEntrance = css`
  animation: ${fadeIn} ${duration.enter} ${EASE} both;
`

const fadeInDimmed = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 0.5;
  }
`

// Entrance for rows that must settle at half opacity (e.g. answered requests).
// rowEntrance fills opacity forward, so a plain opacity declaration on the row
// loses to the animation — the dimmed end value has to live in the keyframes.
export const rowEntranceDimmed = css`
  animation: ${fadeInDimmed} ${duration.enter} ${EASE} both;
`
